import type Message from "owa-service/lib/contract/Message";
import { MailRowDataPropertyGetter, getComputedSelectedRowKeysSize, getSelectedItemParts, getSelectedTableView, isItemPartOperation } from "owa-mail-list-store";
import getItemForMailList from "owa-mail-store/lib/selectors/getItemForMailList";
import { isFirstLevelExpanded } from "owa-mail-list-store/lib/selectors/isConversationExpanded";
import type { TableView } from "owa-mail-list-store";
import type { ClientItem } from "owa-mail-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function getItemOrMessage(tableView: TableView): Message | ClientItem | undefined | null {
    if (isGlobalFeatureEnabled("fwk-ml-reduce-render-scope")) {
        // Check size via the computed selector first to avoid reading Map contents
        // when selection count hasn't changed (avoids unnecessary MobX invalidation).
        if (getComputedSelectedRowKeysSize() !== 1) {
            return undefined;
        }
        const rowKey = [...getSelectedTableView().selectedRowKeys.keys()][0];
        if (isItemPartOperation()) {
            const itemId = getSelectedItemParts()[0];
            return getItemForMailList(itemId, isFirstLevelExpanded(rowKey));
        }
        else if (rowKey) {
            return MailRowDataPropertyGetter.getItem(rowKey, tableView);
        }
        return undefined;
    }
    
    const selectedRowKeys = [...getSelectedTableView().selectedRowKeys.keys()];
    const rowKey = selectedRowKeys.length == 1 ? selectedRowKeys[0] : "";
    if (isItemPartOperation()) {
        // Conversation view
        const itemId = getSelectedItemParts()[0]; // [0] for single selection
        return getItemForMailList(itemId, isFirstLevelExpanded(rowKey));
    }
    else if (rowKey) {
        return MailRowDataPropertyGetter.getItem(rowKey, tableView);
    }
    return undefined;
}
